import axios from 'axios';
import wrapAxios from 'common-datadog/wrapAxios';

export const monolithClient = wrapAxios(
  axios.create({
    baseURL: '/api',
    adapter: 'fetch',
    headers: { ACCEPT: 'application/vnd.cfs-api.v2' },
  }),
);

const internalJavaClient = axios.create({
  adapter: 'fetch',
  baseURL: '/platform',
  timeout: 15_000,
});

internalJavaClient.interceptors.request.use((config) => {
  if (!config.outcome) {
    return config;
  }

  return {
    ...config,
    headers: {
      ...config.headers,
      'expected-mock': config.outcome,
    },
  };
});

export const javaClient = wrapAxios(internalJavaClient);
